// extracted by mini-css-extract-plugin
export default {"freemium-banner-responsive-common":"NI6sSq","freemiumBannerResponsiveCommon":"NI6sSq","rtl":"BnG1oB","ltr":"DV9Swr","overlay":"rWdkbJ","link":"IoI91y","text":"ynPdjt"};